<template>
  <div class="fixed inset-x-0 pointer-events-none pb-2 sm_pb-5">
    <div class="max-w-7xl mx-auto px-2 sm_px-6 lg_px-8">
      <div class="p-2 rounded-lg bg-gray-700 shadow-lg pointer-events-auto sm_p-3">
        <div class="flex items-center justify-between flex-wrap">
          <div class="w-0 flex-1 flex items-center">
            <span class="flex p-2 rounded-lg bg-red-800"> <EyeIcon class="h-6 w-6 text-white" aria-hidden="true" /> </span
            ><span class="ml-3 font-small text-white">
              <slot />
            </span>
          </div>
          <div class="order-2 flex-shrink-0 sm_order-3 sm_ml-2">
            <button
              class="mr-1 flex p-2 rounded-md bg-transparent hover_bg-gray-500 focus_outline-none focus_ring-2 focus_ring-white"
              type="button"
              @click="$emit('on-dismiss')"
            >
              <span class="sr-only">Dismiss</span>
              <XMarkIcon class="h-6 w-6 text-white" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { XMarkIcon } from '@heroicons/vue/24/outline'
import { EyeIcon } from '@heroicons/vue/24/solid'

defineEmits(['on-dismiss'])
</script>
